import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { TYPOGRAPHY } from "@store/theme/design";

Object.assign(priceStyles, {
    productPrice: {
        price: {
            priceText: {
                size: TYPOGRAPHY.size.larger,
                lineHeight: TYPOGRAPHY.lineHeight.smaller,
            },
            unitOfMeasureText: { size: TYPOGRAPHY.size.larger },
        },
    },
});
